const tools = {
  namespaced: true,
  state: {
    //是否關閉 portal
    isBLEMaskOpen: false,

    //upload
    isUploadMaskOpen: false
  },
  mutations: {
    //isOpen is Bollean
    toggleBLEMask(state, isOpen) {
      state.isBLEMaskOpen = isOpen;
    },
    toggleUploadMask(state, isOpen) {
      state.isUploadMaskOpen = isOpen;
    }
  },
  actions: {},
  getters: {}
};

export default tools;
